import { render } from "./AppToggle.vue?vue&type=template&id=56a001a9&scoped=true"
import script from "./AppToggle.vue?vue&type=script&lang=js"
export * from "./AppToggle.vue?vue&type=script&lang=js"

import "./AppToggle.vue?vue&type=style&index=0&id=56a001a9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a001a9"]])

export default __exports__